(function () {
    'use strict';

    function linkedTemplateReference(workflowConfigurationDataService) {
        var baseUrl = '/files/';

        return {
            restrict: 'E',
            template: '<a target="_blank"></a>',
            scope: {
                linkedTemplateId: '='
            },
            replace: true,
            link: function (scope, element) {
                element.attr('href', baseUrl + scope.linkedTemplateId);
                workflowConfigurationDataService.loadLinkedTemplate(scope.linkedTemplateId).then(function (response) {
                    element.html(response.Title);
                });
            }
        };
    }

    linkedTemplateReference.$inject = ['workflowConfigurationDataService'];

    angular.module('ecap.workflow').directive('linkedTemplateReference', linkedTemplateReference);
})();
